/**
 * What the public registration card says beside each of the player's own entries (survey
 * follow-ups 9 and 11). Reads the registration status and the organiser's own money figures the
 * status GET sends (`GET /api/event/[eventId]/participant-register`, the same payment block as the
 * app's registration read — see `OrganiserFigures` in transactionModel).
 */

export type RegisteredEntryPayment = {
  method: string;
  status: string;
  amount: number | null;
  refund: 'full' | 'partial' | null;
  transaction_id: string;
  transaction_amount: number;
  amount_received: number | null;
  amount_paid: number;
  balance_owed: number;
};

export type RegisteredEntryState =
  | { kind: 'withdrawn' }
  /** No transaction at all (an organiser CSV import) or a cancelled one: neither free nor owing. */
  | { kind: 'none' }
  | { kind: 'refunded' }
  | { kind: 'partlyRefunded' }
  | { kind: 'partlyPaid'; paid: number; total: number }
  | { kind: 'owing'; amount: number }
  | { kind: 'free' }
  | { kind: 'paid' };

export function registeredEntryState(entry: {
  status?: string | null;
  payment?: RegisteredEntryPayment | null;
}): RegisteredEntryState {
  if (entry.status === 'withdrawn') return { kind: 'withdrawn' };
  const p = entry.payment;
  // No transaction at all, or a cancelled one: nothing stands recorded (never paid, never free).
  if (!p || p.status === 'cancelled') return { kind: 'none' };
  if (p.status === 'refunded' || p.refund === 'full') return { kind: 'refunded' };
  if (p.balance_owed > 0) {
    return p.amount_paid > 0
      ? { kind: 'partlyPaid', paid: p.amount_paid, total: p.transaction_amount }
      : { kind: 'owing', amount: p.balance_owed };
  }
  if (p.refund === 'partial') return { kind: 'partlyRefunded' };
  if (p.method === 'free' || p.transaction_amount === 0) return { kind: 'free' };
  return { kind: 'paid' };
}
